// PERSONNEL SLIDER
$(document).ready(function(){
    if($('.squeeze-metrics .squeeze-metrics-slider').length) {
        $('.squeeze-metrics .squeeze-metrics-slider').slick({
            draggable: false,
            focusOnSelect: false,
            mobileFirst: true,
            touchMove: false,
            prevArrow: '.squeeze-metrics .prev',
            nextArrow: '.squeeze-metrics .next',
            dots: true,
            dotsClass: 'nav',
            appendDots: $('.squeeze-metrics .nav-wrapper'),
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            responsive: [{
                breakpoint: 780,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }]
        });
    }
});